import React, { Component } from 'react'
import { connect } from 'react-redux'
import infoIcon from '../images/info-icon.png';
class LandingLowerInfo extends Component {
    render() {
        return (
          <div>
            <div className="alert bottomInfo">
                <p>
                    {this.props.strings.LANDING_BOTTOM_ALERT_2}
                    <a href={this.props.strings.LANDING_BOTTOM_ALERT_2_LINK} target="_blank">
                        {this.props.strings.LANDING_BOTTOM_ALERT_2_LINK_TEXT}
                    </a>.
                </p>
                <p>
                    {this.props.strings.LANDING_BOTTOM_ALERT_3}
                    <a href={this.props.strings.LANDING_BOTTOM_ALERT_3_LINK} target="_blank">
                        {this.props.strings.LANDING_BOTTOM_ALERT_3_LINK_TEXT}
                    </a>.
                </p>
            </div>
            <div className="alert sideInfo hideDT">
                <p>
                    {this.props.strings.LANDING_SIDE_ALERT_1}
                </p>
                <p>
                    <b>
                        {this.props.strings.LANDING_SIDE_ALERT_2}
                        <a href={this.props.strings.LANDING_SIDE_ALERT_2_LINK} target="_blank">
                            {this.props.strings.LANDING_SIDE_ALERT_2_LINK_TEXT}
                        </a>.
                    </b>
                </p>
            </div>
          </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
    }
}

const ConnectedLandingLowerInfo = connect(
    mapStateToProps
)(LandingLowerInfo);
export default ConnectedLandingLowerInfo;
